var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BaseQueryWidgetConfiguration, BaseWidgetConfiguration } from "./base-widget";
import { transient } from "aurelia-dependency-injection";
import { DataType, QueryFilter } from "../models/queries/queries.models";
import { QueriesClientService } from "../services/queries/queries-client.services";
import { EntityTypeConfigurationHelper } from '../models/basics/basics.models';
import * as Enumerable from "linq";
import { ChartTypes } from "../views/components/chart/chart";
import { computedFrom } from "aurelia-binding";
var ChartWidgetConfiguration = /** @class */ (function (_super) {
    __extends(ChartWidgetConfiguration, _super);
    function ChartWidgetConfiguration(queriesService, entityTypeConfigurationHelper) {
        var _this = _super.call(this, entityTypeConfigurationHelper) || this;
        _this.queriesService = queriesService;
        _this.chartTypes = [ChartTypes.AreaChart, ChartTypes.Bar, ChartTypes.StackedBar, ChartTypes.StackedHorizontalBar, ChartTypes.Donut, ChartTypes.Funnel, ChartTypes.HorizontalBar, ChartTypes.Line, ChartTypes.Pie, ChartTypes.SolidGauge];
        _this.aggrigationTypes = ["sum", "average", "count"];
        _this.hideLegend = false;
        _this.sortTypes = [" ", "ascending", "descending"];
        _this.filterProperties = new Array();
        return _this;
    }
    ChartWidgetConfiguration.prototype.setModel = function (model) {
        this.model = model;
        this.title = model.title;
        this.setModelOverride(model);
        this.chartLabelColors = model.chartLabelColors;
    };
    Object.defineProperty(ChartWidgetConfiguration.prototype, "getEntity", {
        //get the entity name without spaces
        get: function () {
            return this.entityTypeUri.replace(/\s/g, "");
        },
        enumerable: false,
        configurable: true
    });
    ChartWidgetConfiguration.prototype.aggregationTypeSelected = function (event) {
        //removing aggrigationProperty since for count there is no property for aggregation
        if (event.detail.item == "count")
            this.aggrigationProperty = null;
    };
    ChartWidgetConfiguration.prototype.entityTypeChanged = function () {
        var _this = this;
        this.queriesService.getNameProperties(this.entityTypeUri.replace(/ /g, ''))
            .then(function (nameProperties) {
            _this.nameProperties = nameProperties;
            _this.aggrigationProperties = Enumerable.from(nameProperties).where(function (x) { return x.type == DataType.Number || x.type == DataType.Double; }).toArray();
            _this.aggrigationTypes = _this.aggrigationProperties.length > 0 ? ["sum", "average", "count"] : ["count"];
        });
        this.queriesService.getEntityModels().then(function (x) {
            var entityModel = Enumerable.from(x).first(function (a) { return a.uri && a.uri == _this.entityTypeUri; });
            _this.filterProperties = entityModel.filterProperties;
        });
        if (this.isNewQuery) {
            //clear queries
            this.queries = [];
            this.addQuery();
        }
        else {
            // if (this.queries) {
            //     for (let q of this.queries) {
            //         q.entityType = this.entityType;
            //         q.onEntityTypeChanged();
            //     }
            // }
        }
    };
    ChartWidgetConfiguration.prototype.getModel = function (self) {
        return {
            title: self.title,
            aggrigationType: self.aggrigationType,
            entityTypeUri: self.entityTypeUri,
            nameProperty: self.nameProperty,
            aggrigationProperty: self.aggrigationProperty,
            chartType: self.chartType,
            limit: self.limit,
            hideLegend: self.hideLegend,
            resultSort: self.sortResult,
            drillDownRuleScript: self.drillDownRuleScript,
            chartLabelColors: self.chartLabelColors,
            multiQueryFilters: Enumerable.from(self.queries).select(function (x) {
                return x.Model;
            }).toArray()
        };
    };
    ChartWidgetConfiguration.prototype.runAfterInitializeInternal = function (queryEditor, config) {
        queryEditor.queryId = config.selectedSavedQueryId;
        queryEditor.columns = config.columns;
        queryEditor.selectedFilters = config.queryFilters;
    };
    ChartWidgetConfiguration.prototype.setModelOverride = function (model) {
        var _this = this;
        this.entityTypeUri = model.entityTypeUri;
        this.nameProperty = model.nameProperty;
        this.aggrigationProperty = model.aggrigationProperty;
        this.chartType = model.chartType;
        this.limit = model.limit;
        this.aggrigationType = model.aggrigationType;
        this.hideLegend = model.hideLegend;
        this.sortResult = model.resultSort;
        this.drillDownRuleScript = model.drillDownRuleScript;
        this.chartLabelColors = model.chartLabelColors;
        if (this.model && (this.model.multiQueryFilters || this.model.multiQueryFilters.length > 0))
            this.queries = this.model.multiQueryFilters.map(function (x) {
                var config = x;
                var multiQuery = new MultiQuery(_this.entityTypeConfigurationHelper);
                multiQuery.entityTypeUri = _this.entityTypeUri;
                multiQuery.setModel(config);
                return multiQuery;
            });
        // else if (this.entityType && !(this.model && this.model.multiQueryFilters)) {
        //     this.queries.forEach(x => {
        //         x.queryEditor.activateInternal(this.entityType.type.replace(/\s/g, ""),
        //             () => {
        //                 this.runAfterInitializeInternal(x.queryEditor, x.Model);
        //             });
        //     });
        // }
    };
    Object.defineProperty(ChartWidgetConfiguration.prototype, "isStacked", {
        get: function () {
            return this.chartType == ChartTypes.StackedBar || this.chartType == ChartTypes.StackedHorizontalBar;
        },
        enumerable: false,
        configurable: true
    });
    ChartWidgetConfiguration.prototype.addQuery = function () {
        if (!this.queries) {
            this.queries = [];
        }
        var multiQuery = new MultiQuery(this.entityTypeConfigurationHelper);
        var filter = QueryFilter.getQuery(null, null, null, DataType.Default, true, false, null, false);
        multiQuery.setModel({
            queryFilters: [filter],
            title: "",
        });
        multiQuery.entityTypeUri = this.entityTypeUri;
        this.queries.push(multiQuery);
    };
    ChartWidgetConfiguration.prototype.removeQuery = function (x) {
        this.queries.splice(this.queries.indexOf(x), 1);
    };
    ChartWidgetConfiguration.prototype.addChartLabelColor = function () {
        if (!this.chartLabelColors || this.chartLabelColors.length == 0)
            this.chartLabelColors = [];
        this.chartLabelColors.push({
            label: null,
            color: null
        });
    };
    ChartWidgetConfiguration.prototype.removeLabelColor = function (index) {
        this.chartLabelColors.splice(index, 1);
    };
    ChartWidgetConfiguration.prototype.hidePreview = function (queryEditor) {
        if (queryEditor) {
            queryEditor.showDataGrid = false;
        }
    };
    __decorate([
        computedFrom("entityType"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ChartWidgetConfiguration.prototype, "getEntity", null);
    __decorate([
        computedFrom("chartType"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ChartWidgetConfiguration.prototype, "isStacked", null);
    ChartWidgetConfiguration = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [QueriesClientService, EntityTypeConfigurationHelper])
    ], ChartWidgetConfiguration);
    return ChartWidgetConfiguration;
}(BaseWidgetConfiguration));
export { ChartWidgetConfiguration };
var MultiQuery = /** @class */ (function (_super) {
    __extends(MultiQuery, _super);
    function MultiQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MultiQuery.prototype, "Model", {
        get: function () {
            return this.getModel(this);
        },
        enumerable: false,
        configurable: true
    });
    MultiQuery.prototype.onEntityTypeChanged = function () {
        _super.prototype.entityTypeChanged.call(this);
    };
    MultiQuery.prototype.getModel = function (self) {
        return {
            columns: this._queryEditor.columns,
            queryFilters: this.queryEditor.selectedFilters,
            selectedSavedQueryId: this._queryEditor.selectedSavedQuery ? this._queryEditor.selectedSavedQuery.queryId : -1,
            entityTypeUri: self.entityTypeUri,
            title: this.title
        };
    };
    return MultiQuery;
}(BaseQueryWidgetConfiguration));
export { MultiQuery };
